import Vue from 'vue'
import VueRouter from 'vue-router'


//引入页面文件
import Home from '@/views/home/index.vue'
import NewsList from '@/views/news/newsList.vue'
import NewsDetail from '@/views/news/newsDetail.vue'
import ProfessorDetail from '@/views/professor/detail.vue'
import SearchResult from '@/views/searchPage/searchResult.vue'
import CooperateUnit from '@/views/cooperateUnit/list'
import SingleImage from '@/views/single-image/index.vue'

Vue.use(VueRouter)


//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '厦门市产教融合促进会',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '首页'
    },
  },
  //资讯
  {
    path: '/newsList',
    name: 'NewsList',
    component: NewsList,
    meta: {
      title: '新闻中心',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '新闻中心',
    },
    children: [{
      path: 'newsDetail/:id/:categoryId',
      name: 'NewsDetail',
      component: NewsDetail,
      meta: {
        title: '媒体报道',
        content: {
          keywords: '',
          description: ''
        },
        breadcrumb: '媒体报道',
      },
    }],
  },
  {
    path: '/professor/detail/:id',
    component: ProfessorDetail,
    meta: {
      title: '专家顾问',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '专家顾问',
    },

  },
  {
    path: '/searchPage/searchResult',
    name: 'SearchResult',
    component: SearchResult,
    meta: {
      title: '结果列表',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '搜索结果',
    },

  },
  {
    path: '/singleImage',
    name: 'SingleImage',
    component: SingleImage,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/cooperateUnit/list',
    name: 'CooperateUnit',
    component: CooperateUnit,
    meta: {
      title: '合作单位',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '合作单位',
    },
  },

  // {
  //   path: '*', // 页面不存在的情况下会跳到404页面
  //   redirect: '/404',
  //   name: 'notFound',
  //   hidden: true
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})















export default router
